import { render, staticRenderFns } from "./teacherMatingDetail.vue?vue&type=template&id=0e88635f&scoped=true&"
import script from "./teacherMatingDetail.vue?vue&type=script&lang=js&"
export * from "./teacherMatingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e88635f",
  null
  
)

export default component.exports